export default class SalesBySubfamilyController {
  constructor(ContentService, moment, ProfilePermissionsService, $uibModal) {
    this.service = ContentService;
    this.moment = moment;
    this.permissionsService = ProfilePermissionsService;
    this.modal = $uibModal;
    this.grouping = 'TAG';
  }

  $onInit(){
    this.subscriptions = [];

    this.rows = [];
    this.dateFrom = this.moment(this.dateFrom || new Date());
    this.dateTo = this.moment(this.dateTo || new Date());
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getSalesByTag(){
    this.subscriptions.push(
      this.service.getSalesByTag({
        date_to: this.dateTo.toISOString(),
        date_from: this.dateFrom.toISOString()
      }).subscribe(data => {
        this.rows = data.rows;
      }, () => {})
    );
  }

  getSalesByCategory(){
    this.subscriptions.push(
      this.service.findSalesByCategory({
        date_to: this.dateTo.toISOString(),
        date_from: this.dateFrom.toISOString()
      }).subscribe((data) => {
        this.rows = data.rows;
      }, () => {})
    );
  }

  drillDownOnTag(tag){
    this.subscriptions.push(
      this.service.getSalesByTag({
        date_to: this.dateTo.toISOString(),
        date_from: this.dateFrom.toISOString()
      }, tag.tag_id).subscribe(data => {
        this.rows = data.rows;
        this.title = tag.tag || ''
      }, () => {})
    );
  }

  drillDownOnItem(item_id, name){
    this.subscriptions.push(
      this.service.getSalesByTag({
        date_to: this.dateTo.toISOString(),
        date_from: this.dateFrom.toISOString(),
        item_id: item_id
      }).subscribe((data) => {
        this.rows = data.rows;
        this.title = name;
      })
    );
  }
  openBillDetails(invoiceId){
    var that = this;
    if (this.permissionsService.hasPermission('account-bills') || this.permissionsService.hasPermission('invoice-orders')){
      this.modal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'invoice-details-template.html',
        appendClassName: 'ngdialog-theme-plain',
        controller: ($scope, $uibModalInstance, AccountInformationService) => {
          "ngInject";

          $scope.invoice = {};
          $scope.orders = [];
          $scope.logoUrl = that.service.host + '/api/accounts/logo/' + that.permissionsService.getProfile().account_id + '?t=' + new Date().getTime();
          that.subscriptions.push(
            that.service.getInvoice(invoiceId).subscribe(
              (invoice) => $scope.invoice = invoice,
              (error) => console.log("Error while getting the invoice")
            )
          );

          $scope.getOrders = () => {
            if ($scope.orders.length <= 0) {
              that.subscriptions.push(
                that.service.getOrders(invoiceId).subscribe(
                  (orders) => $scope.orders = orders,
                  (error) => console.log("Error while getting the orders")
                )
              );
            }
          };

          that.subscriptions.push(
            AccountInformationService.getAccountInfo().subscribe(
              (resp) => {
                $scope.account = resp;
              }
            )
          );
          
          $scope.fetchDetails = (order) => {
            if (!order.details || order.details.length <= 0) {
              that.subscriptions.push(
                that.service.getOrderDetails(invoiceId, order.id).subscribe(
                  (details) => {
                    order.details = details;
                    $scope.displayingOrder = order;
                  },
                  (error) => console.log("Error while getting the details for this order")
                )
              );
            }
          };

          $scope.printToCart = (printSectionId) => {
            var innerContents = document.getElementById(printSectionId).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=1024,height=768,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            popupWinindow.document.write(`<html><head><title>Imprimir factura #${$scope.invoice.number}</title><link rel="stylesheet" type="text/css" href="assets/bootstrap.css" /><link rel="stylesheet" type="text/css" href="assets/printstyle.css" /></head><body onload="window.print()">${innerContents}</html>`);
            popupWinindow.document.close();
          };
          
          $scope.closeThisDialog = () => $uibModalInstance.close();
        }
      });
    }
  }
  isGroupedByTag() { return this.rows && this.rows.length && this.rows[0].hasOwnProperty('tag_id'); }
  isGroupedByCategory(){ return this.rows && this.rows.length && this.rows[0].hasOwnProperty('pifamm_id') && !this.rows[0].hasOwnProperty('tag_id');}
  isGroupedByItem(){ return this.rows && this.rows.length && this.rows[0].hasOwnProperty('item_id'); }
  isGroupedByInvoice(){ return this.rows && this.rows.length && this.rows[0].hasOwnProperty('date') && this.rows[0].hasOwnProperty('rnc'); }

  getTotal(item) { return item.total_billed || item.total || 0; }
  getDiscount(item) { return item.discount_billed || item.discount || 0; }
  getOth(item) { return item.oth_total || 0; }
  getVoid(item) { return item.cancelation_total || 0; }
  getReturned(item) { return item.return_total || 0; }
  getPax(item) { return item.pax || 0; }
  getExtraTip(item) { return item.extra_tip || 0; }
  getTaxExemption(item) { return item.taxexemption || 0; }
  getTax10(item) { return item.tax10 || 0; }
  getTax16(item) { return item.tax16 || 0; }

}

 SalesBySubfamilyController.$inject = ['ContentService', 'moment', 'ProfilePermissionsService', '$uibModal'];



// WEBPACK FOOTER //
// ./src/app/pages/sales-by-subfamily/sales-by-subfamily.controller.js